"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RatingGeneralHandler", {
    enumerable: true,
    get: function() {
        return RatingGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("src/helpers/catchError");
const _decimalgeneralhandler = require("../decimal/decimal.general.handler");
let RatingGeneralHandler = class RatingGeneralHandler extends _decimalgeneralhandler.DecimalGeneralHandler {
    async parseUserInput(params) {
        var _this;
        const value = (_this = await super.parseUserInput(params)) == null ? void 0 : _this.value;
        if (typeof value === 'number') {
            var _parseProp;
            const max = parseFloat((_parseProp = (0, _nocodbsdk.parseProp)(params.column.meta)) == null ? void 0 : _parseProp.max);
            if (value < 0 || value > max) {
                _catchError.NcError.invalidValueForField({
                    value: value.toString(),
                    column: params.column.title,
                    type: params.column.uidt
                });
            }
        }
        return {
            value
        };
    }
    async filterLt(args, _rootArgs, _options) {
        const { val, sourceField } = args;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where(sourceField, '<', val);
                if (val > 0) {
                    qb.orWhereNull(sourceField);
                }
            }
        };
    }
    async filterLte(args, _rootArgs, _options) {
        const { val, sourceField } = args;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where(sourceField, '<=', val);
                if (val >= 0) {
                    qb.orWhereNull(sourceField);
                }
            }
        };
    }
    async filterGte(args, _rootArgs, _options) {
        const { val, sourceField } = args;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where(sourceField, '>=', val);
                if (val <= 0) {
                    qb.orWhereNull(sourceField);
                }
            }
        };
    }
};
